import * as React from "react";
import {
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    Button,
    DialogModalType,
    DialogOpenChangeEvent
} from "@fluentui/react-components";

export interface FluentDialogProps
{
    title: string;
    open: boolean;
    submitLabel?: string;
    cancelLabel?: string;
    submitDisabled?: boolean;
    onSubmit?: () => void;
    onCancel?: () => void;
    noActions?: boolean;
    hideCancel?: boolean;
    modalType?: DialogModalType;
    onOpenChange?: (e: DialogOpenChangeEvent) => void;
}

export const FluentDialog: React.FC<React.PropsWithChildren<FluentDialogProps>> = (props) => {
    return (
        <Dialog open={props.open} onOpenChange={props.onOpenChange} modalType={props.modalType ?? "modal"}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{props.title}</DialogTitle>
                    <DialogContent>
                        {props.children}
                    </DialogContent>
                    { !props.noActions &&
                        <DialogActions>
                            <Button appearance="primary" onClick={props.onSubmit} disabled={props.submitDisabled ?? false}>{props.submitLabel ?? "Ok"}</Button>
                            { !props.hideCancel && <Button appearance="secondary" onClick={props.onCancel}>{props.cancelLabel ?? "Cancel"}</Button> }
                        </DialogActions>
                    }
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};